import { useState } from 'react'

export default function useLocalStorage<T>(key: string, initialValue: T) {
  const scopedKey = `@MEETINGS${key}`
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState<T>(() => {
    // Get from local storage by key
    const item = window.localStorage.getItem(scopedKey)
    // Parse stored json or if none return initialValue
    return item ? JSON.parse(item) : initialValue
  })
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value: T | ((val: T) => T)) => {
    // Allow value to be a function so we have same API as useState
    const valueToStore = value instanceof Function ? value(storedValue) : value
    // Save state
    setStoredValue(valueToStore)
    // Save to local storage
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(scopedKey, JSON.stringify(valueToStore))
    }
  }
  return [storedValue, setValue] as const
}
